import Page from "../../pages/Page";
import Logo from "../../assets/mindstack-logo.png";
import Button from "../input/button";
import { Typography } from "@mui/material";

const PageNotFound = () => {
  return (
    <Page pageKey="page-not-found" className="error-page">
      <div className="page-not-found">
        <img className="error-logo" src={Logo} />
        <Typography variant="h1WhiteNoMargin" className="error-header">
          Page Not Found 😔
        </Typography>
        <Typography variant="body1White" className="error-description">
          The page you are looking for does not exist.
        </Typography>
        <Typography
          variant="body1White"
          className="error-description"
          style={{ marginBottom: "24px" }}
        >
          It might have been moved or deleted.
        </Typography>

        <Button
          color="orange"
          size="huge"
          text="Home"
          onClick={() => window.location.replace("/")}
        />
      </div>
    </Page>
  );
};

export default PageNotFound;
